import generateUrl from "./generateUrl";

const requestHeader = {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    headers: {
        'Content-Type': 'application/json',
        'X-Codes': localStorage.getItem("codes")

    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
}

const api = async (key, args, headers = {}) => {
    const url = generateUrl(key, args)
    const header = {
        ...requestHeader,
        headers: {
            ...requestHeader.headers,
            ...headers,
        },
    }

    // if (typeof window?.fetch === 'function') {
    //     return fetch(url, header)
    // }

    const response = await fetch(url, header);
    const message = await response.json();

    if (!response.ok) {
        throw message;
    }

    return message;
}
api.post = async (keyUrl, payload, headers = {}) => {
    const url = keyUrl.includes('http') ? keyUrl : generateUrl(keyUrl)
    const header = {
        ...requestHeader,
        headers: {
            ...requestHeader.headers,
            ...headers,
        },
        method: 'POST',
        body: JSON.stringify(payload),
    }

    const response = await fetch(url, header);
    const message = await response.json();

    if (!response.ok) {
        throw message;
    }

    return message;
}

api.put = async (key, payload = {}, headers = {}) => {
    const url = generateUrl(key)
    const header = {
        ...requestHeader,
        headers: {
            ...requestHeader.headers,
            ...headers,
        },
        method: 'PUT',
        body: JSON.stringify(payload),
    }

    if (typeof window?.fetch === 'function') {
        return await fetch(url, header)
    }
}
api.options = async (headers = {}) => {
    const url = generateUrl('/*')
    const header = {
        ...requestHeader,
        headers: {
            ...requestHeader.headers,
            ...headers,
        },
        method: 'OPTIONS',
    }
    delete header.headers['Content-Type']

    if (typeof window?.fetch === 'function') {
        return await fetch(url, header)
    }
}
export default api


